import styled from "styled-components"

import Flex from "@irati/ui/src/Flex"

interface StyledProps {
  width: number
}

export const Bar = styled(Flex)`
  height: ${({theme}) => theme.spacing.half};
  width: 100%;
  margin-bottom: ${({theme}) => theme.spacing.two};
  background-color: ${({theme}) => theme.colors.utility.highlight};
`

export const BlueProgressBar = styled.div<StyledProps>`
  width: ${({width}) => width}%;
  height: ${({theme}) => theme.spacing.half};
  background-color: ${({theme}) => theme.colors.perkbox.blue};
`
